import { combineReducers } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import AsyncStorage from '../services/storage';

import preferenceReducer from './slices/preference';
import userReducer from './slices/user';
import editingReducer from './slices/editing';
import shiftLogsReducerNew from './slices/shiftLog';
import ShiftLogsReducer from '../../Reducer/shiftLogsReducer';
import TeamShiftLogsReducer from '../../Reducer/teamShiftLogsReducer';
import PreferenceReducer from '../../Reducer/preferenceReducer';

const preferencePersistConfig = {
  key: 'preference',
  storage: AsyncStorage,
  // redux-persist only reads the lowercase `whitelist` key.
  whitelist: ['preferences', 'hierarchy'],
  // Drop transient fields (isLoading, error, modal) persisted by older builds,
  // otherwise a stale `isLoading: true` blocks loadHierarchy/getPreferencesForSite.
  migrate: (state: any) => {
    if (!state) return Promise.resolve(state);
    const { _persist, preferences, hierarchy } = state;
    return Promise.resolve({
      _persist,
      ...(preferences !== undefined && { preferences }),
      ...(hierarchy !== undefined && { hierarchy }),
    });
  },
};
const persistedPreferenceReducer = persistReducer(preferencePersistConfig, preferenceReducer);

const userPersistConfig = {
  key: 'user',
  storage: AsyncStorage,
};
const persistedUserReducer = persistReducer(userPersistConfig, userReducer);
const shiftLogsPersistConfig = {
  key: 'shiftLogs',
  storage: AsyncStorage,
  blacklist: ['isLoading', 'logDetailIsLoading'],
};
const persistedShiftLogsReducer = persistReducer(shiftLogsPersistConfig, shiftLogsReducerNew);

const rootReducer = combineReducers({
  preference: persistedPreferenceReducer,
  user: persistedUserReducer,
  shiftLogs: persistedShiftLogsReducer,
  ShiftLogsReducer: ShiftLogsReducer,
  TeamShiftLogsReducer: TeamShiftLogsReducer,
  PreferenceReducer: PreferenceReducer,
  editing: editingReducer,
});

export default rootReducer;
